export default __webpack_public_path__ + "static/media/referable-icon.f0822c6f.svg";